<template>
    <md-card>
        <md-card-header>
            <h4 class="title">
            <md-icon>list</md-icon>
            캠페인 목록
            </h4>
        </md-card-header>
        <md-card-content>
            <table class="flex-table mb10">
                <tr>
                <th>캠페인</th>
                <td>
                    <div class="inline-flex">
                    <input v-focus type="text" v-model="cmpPreviewListQuery.cCustGrpNm" v-on:keyup.enter="sendQuery">
                    <button @click="sendQuery">
                        <md-icon>search</md-icon>
                        검색
                    </button>
                    </div>
                </td>
                </tr>
            </table>

            <div class="table-header-info">
              <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
              <div>
                <select v-model="pagination.perPage" name="pages" @change="perPageChange">
                  <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                    {{ item }}
                  </option>
                </select>
              </div>
            </div>

            <grid ref="cmpPreviewListGrid"
                :data="gridProps.data"
                :columns="gridProps.columns"
                :options="gridProps.options"
                :theme="gridProps.theme"
                :rowHeaders="gridProps.rowHeaders"
                :columnOptions="gridProps.columnOptions"
                :language="gridProps.lang"
                @click="onClickModalRow"
                @response="response"
            ></grid>
        </md-card-content>
    </md-card>
</template>
<script>
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import session from "@/kuaa/kuaa-sessions";
import Swal from "sweetalert2";
import moment from "moment";

import { Grid } from '@toast-ui/vue-grid';

export default {
  name: "cmpPreviewListComp",
  props: {
  },

  components: {
    grid: Grid
  },

  created() {
    this.initGrid();
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },
  data(){
    return {
      cmpPreviewListQuery : {
        cCustGrpNm: ''
      },
      gridProps: {},
      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 500],
        total: 0
      },
    }
  },

  methods: {
    sendQuery (){
      let option = {
        cCustGrpNm : this.cmpPreviewListQuery.cCustGrpNm
      };
      this.$refs.cmpPreviewListGrid.invoke("readData", 1, option);
    },
    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_CMP_PREVIEW, false, this.pagination);
      this.gridProps['el'] = this.$refs.cmpPreviewListGrid;
      this.gridProps['columns'] = [
          {header: '캠페인 ID', name: 'CCustGrpId', sortable: true},
          {header: '캠페인명', name: 'CCustGrpNm', sortable: true}
        ];
      this.gridProps['options'].bodyHeight = 590;
    },
    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.cmpPreviewListGrid, event, this.pagination);
    },
    response(e) {
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e);
      }
    },
    /**
     * 그리드 클릭
     */
    onClickModalRow(item) {
      let _this = this;
      if(item.instance.getRow(item.rowKey) != null) {
        this.$emit('returnCmpPreview', item.instance.getRow(item.rowKey));
      }
    },
  }
}
</script>

<style lang="css" scoped>
</style>